module.exports = __webpack_public_path__ + "img/lietuvaskaito-original-960.69149da4.png";